import React, { useContext } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import ActiveControl from '../../../components/ActiveControl';
import useUnitEquivalenceService from '../../../app/services/hooks/useUnitEquivalenceService';

interface Props {
    unitEquivalenceId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const UnitEquivalenceSwitchChange = ({ unitEquivalenceId, checkValue, callbackSuccess }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const [checked, setChecked] = React.useState<boolean>(checkValue);

    const { activeUnitEquivalence, fetchingActiveUnitEquivalence } = useUnitEquivalenceService();

    const active = (value: boolean) => {
        setChecked(value);

        activeUnitEquivalence(unitEquivalenceId, value, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });

                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={unitEquivalenceId} callback={active} />;
};

export default UnitEquivalenceSwitchChange;
